import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { Icon as e } from "../../../../components/Icon/index.js";
import { LikeButtonContainer as a, CountText as l } from "./style.js";
import { ThumbsUpSolid as p, ThumbsUp as s } from "@pelando/fontawesome/icons";
import { useTranslation as u } from "../../../../hooks/useTranslation/index.js";
function d({
  count: o = 0,
  liked: n,
  ...r
}) {
  const { t: i } = u("common");
  return /* @__PURE__ */ m(a, { type: "button", ...r, children: [
    o !== 0 && /* @__PURE__ */ t(l, { children: o }),
    /* @__PURE__ */ t(e, { icon: n ? p : s, "aria-label": i("like-button-aria-label") })
  ] });
}
export {
  d as LikeButton
};
